/**
 * @file items
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'

class Items extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (
            <div id="items">
                <div className="goods">
                    <div className="goods-item item1">
                        <div className="text">激发孩子学习兴趣</div>
                    </div>
                    <div className="goods-item item2">
                        <div className="text">让孩子自信说中文</div>
                    </div>
                    <div className="goods-item item3">
                        <div className="text">亦师亦友专属相伴</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Items
